// Generated by ReScript, PLEASE EDIT WITH CARE


function getTypeFromAuthString(requirement) {
  switch (requirement) {
    case "business" :
        return /* Business */1;
    case "house_shift" :
    case "houseshifting" :
        return /* HouseShift */2;
    default:
      return /* Personal */0;
  }
}

function requirementToString(requirement) {
  switch (requirement) {
    case /* Personal */0 :
        return "personal";
    case /* Business */1 :
        return "business";
    case /* HouseShift */2 :
        return "house_shift";
    
  }
}

function requirementfromString(requirement) {
  switch (requirement) {
    case "business" :
        return /* Business */1;
    case "house_shift" :
        return /* HouseShift */2;
    case "personal" :
        return /* Personal */0;
    default:
      return /* Personal */0;
  }
}

export {
  getTypeFromAuthString ,
  requirementToString ,
  requirementfromString ,
}
/* No side effect */
